import styled from "@emotion/styled";
import { MedalIcon, TrophyIcon } from "components/Icons";
import { NAV_LINKS } from "config/consts";
import { useIsMobile } from "hooks/useDeviceType";
import { MouseEventHandler, useState } from "react";
import { GlobalStore } from "store/global/GlobalStore";
import { useAccount } from "wagmi";
import { getBlockExplorerForNetwork } from "../../../../../../../utils/chainUtils";
import { CopyButton } from "components/CopyButton/CopyButton";
import ViewBlock from "../../../../../../../img/butter_svgs/ViewBlock.svg?react";
import { css } from "@emotion/react";
import { Chain } from "viem/chains";
import { Address } from "viem";

export const OptionGetGuildRole = () => {
  const onClick = () => window.open(NAV_LINKS.GUILD, "_blank");
  return (
    <ProfileActionsOption onClick={onClick}>
      <MedalIcon width={22} height={22} /> <span>Choose your title</span>
    </ProfileActionsOption>
  );
};

export const OptionClaimBadges = () => {
  const onClick = () => window.open(NAV_LINKS.BADGES, "_blank");
  return (
    <ProfileActionsOption onClick={onClick}>
      <TrophyIcon width={22} height={22} /> <span>Claim your achievements</span>
    </ProfileActionsOption>
  );
};

export const OptionCopyAddress = () => {
  const [isCopied, setIsCopied] = useState(false);
  const { address } = useAccount();
  const isCopiedText = isCopied ? "Copied" : "Copy address";

  if (address == null) return null;

  return (
    <ProfileActionsOption onClick={() => null}>
      <CopyButton
        isCopied={isCopied}
        setIsCopied={setIsCopied}
        copyValue={address}
        iconPlacement="left"
        iconSize={22}
        iconGap={8}
        buttonCss={css`
          padding: 0;
          color: inherit;
          gap: 0;
        `}
        buttonType={"link"}
      >
        {isCopiedText}
      </CopyButton>
    </ProfileActionsOption>
  );
};

export const OptionViewOnExplorer = () => {
  const { address } = useAccount();
  const network = GlobalStore.useState(s => s.network);

  return (
    <ProfileActionsOption onClick={() => openAddressInBlockExplorer(network, address)}>
      <ViewBlock
        css={css`
          width: 22px;
          height: 22px;
        `}
      />{" "}
      <span>View in explorer</span>
    </ProfileActionsOption>
  );
};

export const openAddressInBlockExplorer = (chain: Chain, address: Address | undefined) =>
  window.open(`${getBlockExplorerForNetwork(chain)}address/${address ? address : ""}`, "_blank");

// Sub-components

interface ProfileActionsOptionContainerProps {
  isMobile: boolean;
}

const ProfileActionsOptionContainer = styled.button<ProfileActionsOptionContainerProps>`
  display: flex;
  width: 100%;
  gap: 8px;
  padding: ${props => (props.isMobile ? "13px 12px" : "10px")};
  align-items: center;
  border-radius: 14px;
  font-size: ${props => props.theme.fontSize[5]};
  background: none;
  border: none;
  color: ${props => props.theme.font.primary.default};
  text-align: start;
  line-height: 130%;

  &:hover {
    background-color: ${props => props.theme.surface.alt.secondary.hover};
  }
`;

const ProfileActionsOption = ({
  children,
  onClick,
}: React.PropsWithChildren<{ onClick: MouseEventHandler<HTMLButtonElement> }>) => {
  const isMobile = useIsMobile();

  return (
    <ProfileActionsOptionContainer onClick={onClick} isMobile={isMobile}>
      {children}
    </ProfileActionsOptionContainer>
  );
};
